/* 

Copyright© Celligence International, LLC - 2023

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import "../index.css";

export const LoadingSpinner = ({ isLoading, mobileView }) => {
  return (
    <div
      className="Status"
      style={{
        display: isLoading === "pending" ? "flex" : "none",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: mobileView && "absolute",
        top: mobileView && "calc(50vh - 80px)",
        left: mobileView && "calc(50vw - 40px)",
        opacity: isLoading === "pending" ? 1 : 0,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="spinner" />
      </div>
    </div>
  );
};

export const FailedToLoad = () => {
  const theme = useTheme();
  const email = theme.system?.esignEmail;
  const companyName = theme.system?.companyName;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Typography>
        An error occurred while loading the document. Please try again
        later. If the problem persists, please contact us
        {email ? ` at ${email}` : ""}, and we will help resolve the issue.
        {companyName
          ? ` We at ${companyName} strive to provide the best possible experience for our users.`
          : ""}
      </Typography>
    </div>
  );
};

const Status = ({ isLoading, children, mobileView = false }) => {
  return (
    <>
      <LoadingSpinner isLoading={isLoading} mobileView={mobileView} />
      {isLoading === "error" && (<FailedToLoad />)}
      <div
        style={{
          textAlign: "center",
          width: "100%",
          opacity: isLoading === "pending" ? 0 : 1,
          height: isLoading === "pending" && "0px",
        }}>
          {children}
        </div>
    </>
  );
};

export default Status;
